/* Pel-Freez Biologicals theme — global behaviour (loaded on every page).
   Header mega menu + mobile drawer, carousels, quantity steppers, generic tabs, and the
   theme.register(init) hook that feature scripts (product-form.js, cart.js, ...) use so
   they run on DOMContentLoaded and again on shopify:section:load in the theme editor. */
window.theme = window.theme || {};
(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, root) { return (root || doc).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  var inits = [];
  var ready = false;
  window.theme.register = function (init) {
    inits.push(init);
    if (ready) init(doc);
  };
  function runInits(root) { inits.forEach(function (init) { init(root); }); }

  /* ---------- Header: mega menu (click/keyboard) + mobile drawer ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    var items = $$('[data-nav-item]', header);
    function closeAll(except) {
      items.forEach(function (li) {
        if (li !== except) {
          li.classList.remove('is-open');
          var a = li.querySelector('.site-nav__link');
          if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
        }
      });
    }
    items.forEach(function (li) {
      var link = li.querySelector('.site-nav__link');
      var mega = li.querySelector('[data-mega]');
      if (!link || !mega) return;
      // First tap on touch devices opens the panel; second tap follows the link.
      link.addEventListener('click', function (e) {
        var isTouch = window.matchMedia('(hover: none)').matches;
        if (isTouch && !li.classList.contains('is-open')) {
          e.preventDefault();
          closeAll(li);
          li.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          closeAll(li);
          li.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
          var first = mega.querySelector('a');
          if (first) first.focus();
        }
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); link.focus(); }
      });
    });
    doc.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-item]')) closeAll();
    });

    // Nested tree toggles (mobile accordion + touch fallback for tab/flyout columns)
    $$('.nav-tree__toggle', header).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var li = btn.parentElement;
        var open = !li.classList.contains('is-open');
        Array.prototype.forEach.call(li.parentElement.children, function (sib) {
          if (sib !== li) { sib.classList.remove('is-open'); var t = sib.querySelector(':scope > .nav-tree__toggle'); if (t) t.setAttribute('aria-expanded', 'false'); }
        });
        li.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    // (not .mega--columns: its children are always visible, so a group heading is a plain link)
    $$('.mega:not(.mega--columns) .nav-tree__item.has-children > .nav-tree__link', header).forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!window.matchMedia('(hover: none)').matches) return;
        var li = a.parentElement;
        if (!li.classList.contains('is-open')) {
          e.preventDefault();
          Array.prototype.forEach.call(li.parentElement.children, function (sib) { sib.classList.remove('is-open'); });
          li.classList.add('is-open');
        }
      });
    });

    var toggle = $('[data-menu-toggle]', header);
    var drawer = $('[data-mobile-menu]', header);
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = drawer.hasAttribute('hidden');
        if (open) drawer.removeAttribute('hidden'); else drawer.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.classList.toggle('is-open', open);
      });
    }
  }

  /* ---------- Carousels (scroll-snap tracks with prev/next) ---------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (c) {
      var track = $('[data-carousel-track]', c);
      var prev = $('[data-carousel-prev]', c);
      var next = $('[data-carousel-next]', c);
      if (!track) return;
      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(root) {
    $$('[data-qty]', root).forEach(function (q) {
      var input = $('input', q);
      var minus = $('[data-qty-minus]', q);
      var plus = $('[data-qty-plus]', q);
      if (!input) return;
      function set(v) {
        var min = parseInt(input.min, 10); if (isNaN(min)) min = 0;
        var max = parseInt(input.max, 10);
        v = Math.max(min, v);
        if (!isNaN(max)) v = Math.min(max, v);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) - 1); });
      if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1); });
    });
  }

  /* ---------- Generic tabs ([data-tabs] > [data-tab] / [data-panel]) ---------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (tabs) {
      $$('[data-tab]', tabs).forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          var key = tab.getAttribute('data-tab');
          $$('[data-tab]', tabs).forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          $$('[data-panel]', tabs).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
          window.dispatchEvent(new Event('resize')); // carousels inside a hidden panel measured 0 wide at init
        });
      });
    });
  }

  window.theme.register(function (root) {
    initCarousels(root);
    initQty(root);
    initTabs(root);
  });

  doc.addEventListener('DOMContentLoaded', function () {
    doc.documentElement.classList.remove('no-js');
    initHeader();
    ready = true;
    runInits(doc);
  });
  doc.addEventListener('shopify:section:load', function (e) {
    runInits(e.target);
    if (e.target.querySelector('[data-header]')) initHeader();
  });
})();
